import { Button } from '@veneer/core';
import styled from 'styled-components';
import { color, layout } from '../../../GlobalStyles';

const { size3, size6, cornerRadius2 } = layout;
const { gray3, royalBlue7 } = color;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size6}px;
  margin-top: 40px;
`;

export const Title = styled.span.attrs({ className: 'subtitle-regular' })``;

export const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${size3}px;
  flex-wrap: wrap;
`;
export const PlanButton = styled(Button)<{ selected?: boolean }>`
  flex: 1;
  height: 36px;
  background-color: ${({ selected }) =>
    selected ? royalBlue7 : 'transparent'} !important;
  color: ${({ selected }) => (selected ? color.white : 'initial')} !important;
  border: 1px solid ${({ selected }) => (selected ? royalBlue7 : gray3)} !important;
  border-radius: ${cornerRadius2}px !important;

  &:hover {
    background-color: ${({ selected }) =>
      selected ? royalBlue7 : gray3} !important;
    color: ${({ selected }) => (selected ? color.white : 'initial')} !important;
  }
`;
